import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { CookieBanner } from './components/CookieBanner';
import { CartProvider } from './context/CartContext';
import { CartDrawer } from './components/CartDrawer';
import { motion, AnimatePresence } from 'motion/react';
// Lazy load pages for better performance
const Home = lazy(() => import('./pages/Home'));
const Checkout = lazy(() => import('./pages/Checkout'));
const Products = lazy(() => import('./pages/Products'));
const Offers = lazy(() => import('./pages/Offers'));
const Sectors = lazy(() => import('./pages/Sectors'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const ProductDetail = lazy(() => import('./pages/ProductDetail'));

// Legal pages
const Terminos = lazy(() => import('./pages/legal/Terminos'));
const Privacidad = lazy(() => import('./pages/legal/Privacidad'));
const Seguridad = lazy(() => import('./pages/legal/Seguridad'));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  React.useEffect(() => {
    // Force browser to not remember scroll position on refresh
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

export default function App() {
  const [isCartOpen, setIsCartOpen] = React.useState(false);

  return (
    <HelmetProvider>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <div className="flex flex-col min-h-screen">
            <Navbar onOpenCart={() => setIsCartOpen(true)} />
            <main className="flex-grow">
              <Suspense fallback={
                <div className="h-screen flex items-center justify-center bg-brand-white">
                  <div className="w-12 h-12 border-4 border-brand-green border-t-brand-dark-blue rounded-full animate-spin"></div>
                </div>
              }>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/productos" element={<Products />} />
                  <Route path="/producto/:id" element={<ProductDetail />} />
                  <Route path="/ofertas" element={<Offers />} />
                  <Route path="/sectores" element={<Sectors />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/finalizar-pedido" element={<Checkout />} />
                  <Route path="/nosotros" element={<About />} />
                  <Route path="/contacto" element={<Contact />} />
                  <Route path="/terminos" element={<Terminos />} />
                  <Route path="/privacidad" element={<Privacidad />} />
                  <Route path="/seguridad" element={<Seguridad />} />
                </Routes>
              </Suspense>
            </main>
            <Footer />
            <WhatsAppButton />
            <CookieBanner />
            <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
          </div>
        </Router>
      </CartProvider>
    </HelmetProvider>
  );
}
